import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pqTruncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
  public transform (text: string, limit: number) {
    let s = '';

    // clean up already truncated text for space between eclipse and final word
    if (text && text.substring(text.length - 3, text.length) === '...') {
      text = text.substring(0, text.length - 3).trim() + '...';
    }

    // do truncate if needed
    if (text && (text.length > limit)) {

      // truncate text based on required length
      let tmpText = text.substring(0, limit);

      // truncate again to the next empty space and add eclipse
      tmpText = tmpText.substring(0, Math.min(tmpText.length, tmpText.lastIndexOf(' '))) + '...';

      // cleanup any unclosed html tags
      let tmpEle = document.createElement('div');
      tmpEle.innerHTML = tmpText;

      s = tmpEle.innerHTML;
    } else {
      s = text;
    }

    return s.trim();
  }
}
